// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@awc/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 0,
    css: css`
        padding-left: 10%;
        ${xScreen("lte", "md")} {
            padding-left: 0;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    css: css`
        ul {
            padding-right: 0;
        }
        margin-bottom: 16px;
    `,
};
signInCreateNewAccountStyles.createNewAccountButton = {
    css: css`
        ${({ isFullWidth }: { isFullWidth?: boolean }) =>
            isFullWidth
                ? css`
                      width: 100%;
                  `
                : ""}
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
        gap: 10px;
        justify-content: flex-end;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h3",
    as: "h2",
};

signInCreateNewAccountStyles.centeringWrapper = {
    css: css`
        display: flex;
        height: 300px;
        justify-content: center;
        align-items: center;
    `,
};
